import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router';

import { FormPage } from '@checkit/react-components';
import { AddIcon } from '@checkit/react-components/build/components/Icons';

import { useAxiosDispatch } from '../../middleware/axios';
import { createSnackbar } from '../../notifications/actions';
import {
  createLibrary,
  isCreateLibrarySuccess
} from '../actions';
import { LibraryForm } from '../form/LibraryForm';
import { LibraryDto } from '../state';

import { messages } from './NewLibrary.translations';

export const NewLibrary: React.FC<RouteComponentProps> = ({ history }) => {
  const { formatMessage } = useIntl();
  const dispatch = useAxiosDispatch( );

  async function handleSubmit(data: LibraryDto) {
    const action = createLibrary(data);
    await dispatch(action).then(function onSuccess(resultingAction) {
      if (!isCreateLibrarySuccess(resultingAction)) {
        throw new Error('Resulting action of library creation is invalid');
      }
      dispatch(createSnackbar({
        message: formatMessage(messages['library.new.success']),
        options: { variant: 'success' }
      }));
    }).catch(function handleError(err) {
      dispatch(createSnackbar({
        message: formatMessage(messages['library.new.error']),
        options: { variant: 'error' }
      }));
      // re-throw the error so that the library form knows the creation failed
      throw err;
    });
  }

  return (
    <FormPage pageTitle={formatMessage(messages['library.new.pageTitle'])} pageIcon={<AddIcon />}>
      <LibraryForm code={null} history={history} handleSubmit={handleSubmit} />
    </FormPage>
  );
};
